import { Pagination, paginationToParams } from '../../Pagination';

export interface StockHistoryReportFilter {
  productID: number;
  optionValueID?: string;
  pagination: Pagination;
}

export const getDefaultStockHistoryReportFilter =
  (): StockHistoryReportFilter => ({
    productID: 0,
    pagination: {
      page: 0,
      pageSize: 10,
    },
  });

export const stockHistoryReportFilterToQueryParams = (
  filter: StockHistoryReportFilter,
) => ({
  'product-id': filter.productID,
  'option-value-id': filter.optionValueID,
  ...paginationToParams(filter.pagination),
});
